"use client";
import React from "react";
import DefaultEditor from "react-simple-wysiwyg";
import { post } from "../../lib/fetchData";
import CustomModal from "../../ui/modals/CustomModal";
import { Link } from "react-router-dom";

export default function FaqNew() {
  const [faq, setFaq] = React.useState<any>({});
  const [answer, setAnswer] = React.useState<any>("");
  const [loading, setLoading] = React.useState<any>(false);
  const closeModal = () => {
    setModal({ ...modal, onopen: false });
  };
  const [modal, setModal] = React.useState<any>({
    onopen: false,
    onclose: closeModal,
    title: "New Faq",
  });

  React.useEffect(() => {}, []);

  const onHtmlChange = (e: any) => {
    setAnswer(e.target.value);
    console.log(answer);
  };

  const handleSubmit = async () => {
    console.log("SUBMITTING");
    setLoading(true);
    try {
      const resp = await post(
        {
          question: faq.question,
          answer: answer,
          mode: "add-faq",
        },
        "create_faq"
      );

      if (resp.status === 1) {
        setModal({
          ...modal,
          onopen: true,
          severity: resp.status ? "success" : "error",
          message: resp.message,
        });
      }
    } catch (error: any) {
      setModal({
        ...modal,
        onopen: true,
        severity: "error",
        message: error.message,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e: any) => {
    console.log(e.target);
    const name = e.target.name;
    setFaq({ ...faq, [name]: e.target.value });
  };

  return (
    <React.Fragment>

              <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/faq">FAQ</Link>
          <span>Add New</span>
        </div>
      </div>


      <div className="py30 px20">
        <div className={loading ? " input iconed " : " input "}>
          <label>Question</label>
          <input
            type="text"
            className="input-form-control"
            name="question"
            onChange={handleInputChange}
            placeholder={"FAQ Question "}
          />
        </div>

        <div className="mb10">
          <DefaultEditor
            className="form-control"
            placeholder="FAQ Answer"
            value={answer}
            onChange={onHtmlChange}
          />
        </div>
        <button
          type="submit"
          className="btn btn-medium"
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? "Working..." : " Add FAQ "}
        </button>
      </div>

      {modal.onopen && <CustomModal data={modal} />}
    </React.Fragment>
  );
}
